import { Pipe, PipeTransform } from '@angular/core';
import { Kursteilnehmer } from '../_models/teilnehmer';
@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform
{
  transform(items: Kursteilnehmer[], searchText: string): any[]
  {
    if (!items) return [];
    if (!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter(it =>
    {

      console.log(it)
      return it.nachname.toLowerCase().includes(searchText) || it.vorname.toLowerCase().includes(searchText);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/_helpers/filter.pipe.ts